import { type QSsrContext } from '#q-app'
import { Quasar, type QuasarLanguage } from 'quasar'
import { $t } from 'src/boot/common/i18n'
import { type LocalesCode, quasarLocales } from 'src/i18n/locales'

export const useChangeQuasarLocale = () => {
  // Get the Quasar language packages, not working with a variable
  // set to  '../../../../node_modules/quasar/lang/*.js' if we have a lot of locales supported
  const langList = import.meta.glob(
    '../../../../node_modules/quasar/lang/(en-US|fr).js'
  )

  const changeQuasarLocale = async (
    loc: LocalesCode,
    ssrContext?: QSsrContext | null
  ) => {
    // Set Quasar locale
    const lang =
      await langList[
        `../../../../node_modules/quasar/lang/${quasarLocales[loc]}.js`
      ]()

    Quasar.lang.set((lang as { default: QuasarLanguage }).default, ssrContext)
    // Change translation for Quasar components
    Quasar.lang.props.table.noData = $t('components.noData')
    Quasar.lang.props.table.noResults = $t('components.noResults')
  }

  return { changeQuasarLocale }
}
